// Turbo Drive View.render stores the renderer on `this`, then awaits
// prepareToRenderSnapshot (head merge / stylesheet load). A second visit
// can finish first and `delete this.renderer` in its finally block.
// The stale render then throws:
//   TypeError: undefined is not an object (evaluating 'this.renderer.renderMethod')
// (Safari / iOS WKWebView) or Chrome's "reading 'renderMethod'".
//
// Honeybadger: https://app.honeybadger.io/projects/130328/faults/134069331
// The later visit already painted the page; the leftover rejection is noise.

export function isStaleTurboRendererError(errorOrMessage) {
  const message =
    typeof errorOrMessage === "string" ? errorOrMessage : errorOrMessage?.message || String(errorOrMessage ?? "")

  return (
    /this\.renderer\.renderMethod/.test(message) ||
    /reading ['"]renderMethod['"]/.test(message)
  )
}

export function guardTurboViewRender(session = globalThis.Turbo?.session) {
  const view = session?.view
  if (!view?.render || view.__sparkStaleRendererGuarded) {
    return view ?? null
  }

  const originalRender = view.render.bind(view)
  view.render = async function guardedTurboRender(renderer) {
    try {
      return await originalRender(renderer)
    } catch (error) {
      if (isStaleTurboRendererError(error)) {
        return
      }
      throw error
    }
  }
  view.__sparkStaleRendererGuarded = true
  return view
}
